//// Nice selectors
(function($, window, undefined) {

  var defaults = {
    initValue:null,
    onChange: null,
    hasOptions: false,
    selected: null,
    desktopSlideOut:false,
  }

  function formUI(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  formUI.prototype = {
    init: function() {      
      var _this = this
      this.input = this.element.find('.wbsk-ui-option-toggle__input')
      this.parent = this.element.find('.wbsk-ui-option-toggle__parent')
      this.optionsWrap = this.element.find('.wbsk-ui-option-toggle__options-wrap')
      this.options = this.element.find('.wbsk-ui-option-toggle__option')
      this.confirm = this.element.find('.wbsk-ui-option-toggle__confirm')
      //update value on init  
      this.settings.initValue = this.settings.initValue ? this.settings.initValue.toString().split(',') :  [$(this.options[0]).attr('data-val')]
      if(this.settings.hasOptions && this.settings.selected == null && this.options.length > 0){
        this.updateValue(this.settings.initValue)
      }
      //bind handlers
      this.parent.on('click', function(e) {
        if (_this.element.hasClass('is-open')) {
          _this.closeAll()
        } else {
          _this.open()
        }
      })   
      this.options.on('click', function(e) {
        _this.updateValue($(e.target).attr('data-val'))
      })   
      
      this.confirm.on('click', function(e) {
        e.preventDefault()
        _this.closeAll()
      })  
    
    },
    
    closeAll:function(){
      $('.wbsk-ui-option-toggle__bg-close').remove()
      $('.wbsk-ui-option-toggle').removeClass('is-open')
      $('body').removeClass('formUI--is-open')
      this.unBindClick()
    },
    
    open:function(){
      var _this = this
      this.closeAll()
      if(this.settings.desktopSlideOut == true){
        this.element.prepend('<span class="wbsk-ui-option-toggle__bg-close"></span>')
      }
      this.element.addClass('is-open')
      $('body').addClass('formUI--is-open')
      setTimeout(function(){
        _this.bindClick()
      },100)
    },
    
    bindClick:function(){
      var _this = this
      $('body').bind('click',function(e){
        if(!$(_this.element).has($(e.target)).length || !$(e.target).parents(_this.element).length || $(e.target).hasClass('wbsk-ui-option-toggle__bg-close')){
          _this.closeAll()
        }
      });
    },
    
    unBindClick:function(){
      $('body').unbind('click')
    },
    
    updateValue:function(value){
      const _this = this
      let callbackData = value
      if(_this.settings.allowMultiple && value != 'All'){
        const allSelector = this.element.find('[data-val="All"]')
        value = Array.isArray(value) ? value : [value]
        value.forEach( item => {
          const $selector = _this.element.find(`[data-val="${item}"]`)
          const isNowSelected =  $selector.hasClass('is-selected') ? false : true
          $selector.toggleClass('is-selected',isNowSelected)
          return isNowSelected ? true : false
        })
        const selectedItems = Array.from(this.element.find('.is-selected:not([data-val="All"])')).map( (item,index) => $(item).attr('data-val'))
        if(selectedItems.length){
          allSelector.removeClass('is-selected')
          const elementText = `${selectedItems[0]}${selectedItems.length > 1 ? ` +più` : ''}`
          this.parent.text(elementText)
          this.element.data('val', selectedItems)
          this.input.val(selectedItems.join(',')) 
          callbackData = selectedItems
        }else{
          _this.updateValue('All')
        }
      }else{
        const $selector = _this.element.find(`[data-val="${value}"]`)
        $selector.addClass('is-selected').siblings().removeClass('is-selected')
        this.element.data('val', value)
        this.parent.text($selector.text())
        this.input.val(value)
        this.closeAll()
      }
      
      if (typeof this.settings.onChange === "function") {
        this.settings.onChange(callbackData,_this)
      }
    },
  }

  $.fn.formUI = function(settings) {
    return this.each(function () {
      $.data(this, 'formUI', new formUI(this, settings))
    })
  }

}(jQuery, window));